import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { config } from '../config';

export const useQueryLanguage = () => {
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const langParam = searchParams.get('lang');

  React.useEffect(() => {
    if (langParam && config.availableLanguages.includes(langParam) && langParam !== i18n.language) {
      i18n.changeLanguage(langParam);
    }
  }, [langParam, i18n]);

  return langParam;
};